module.exports = __webpack_public_path__ + "static/media/leadershipDarkDesktop.ccf7f622.png";